import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Text, Link, Box, Structure, Section, Strong, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaTelegram } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"bot/oplata-kriptoi-v-telegram-magazine"} />
		<Helmet>
			<title>
				Оплата криптовалютой в Telegram магазине | xRocket
			</title>
			<meta name={"description"} content={"Подключение оплат при помощи криптовалют TON, USDT, BTC прямо внутри телеграм магазина"} />
			<meta property={"og:title"} content={"Оплата криптовалютой в Telegram магазине | xRocket"} />
			<meta property={"og:description"} content={"Подключение оплат при помощи криптовалют TON, USDT, BTC прямо внутри телеграм магазина"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Structure
			cells-number-total="2"
			quarkly-title="Navbar"
			position="relative"
			z-index="3"
			nout-z-index="9"
			padding="12px 0px 12px 0px"
		>
			<Override
				slot="Content"
				grid-template-columns="5fr 3fr"
				nout-grid-template-columns="3fr 3fr"
				lg-grid-template-columns="1fr 2fr"
				md-grid-template-columns="1fr 2fr"
				sm-grid-template-columns="1fr"
			>
				<Override slot="cell-0">
					<LinkBox href="https://www.ucoz.ru/bot/" pointer-events="none">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
					</LinkBox>
					<LinkBox flex-direction="row" href="/en" display="none" sm-display="flex">
						<Text
							color="#000000"
							text-decoration-line="initial"
							font="--menu"
							transition="--opacityOut"
							hover-opacity=".8"
							padding="5px 5px 5px 5px"
						>
							English
						</Text>
					</LinkBox>
					<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
						<Override
							slot="Content"
							background="rgba(255, 255, 255, 0)"
							md-background="--background"
							padding="8px 16px 8px 16px"
							nout-z-index="9999"
							nout-background="--background"
						/>
						<Override slot="Button Icon" size="32px" />
						<Override
							slot="Button Text"
							nout-text-transform="uppercase"
							nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif"
							nout-letter-spacing="1px"
							sm-display="flex"
							sm-align-items="center"
							sm-justify-content="center"
						>
							меню
						</Override>
						<Override slot="Wrapper" nout-z-index="9" />
						<Box
							width="100%"
							display="flex"
							grid-gap="20px"
							md-flex-direction="column"
							nout-flex-direction="column"
							nout-margin="20px 0px 0px 0px"
							nout-grid-gap="16px"
						>
							<Link
								href="https://www.ucoz.ru/bot/"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Магазин в Телеграм
							</Link>
							<Link
								href="/bot/#easy"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Возможности
							</Link>
							<Link
								href="/bot/#top"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Преимущества
							</Link>
							<Link
								href="/bot/#price"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Цены
							</Link>
							<Link
								href="/bot/#example"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Примеры
							</Link>
							<Link
								href="/bot/#faq"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								FAQ
							</Link>
						</Box>
						<Box
							display="none"
							sm-display="flex"
							sm-flex-direction="column"
							sm-align-items="flex-start"
							sm-grid-gap="16px"
							sm-margin="16px 0px 0px 0px"
						>
							<Link
								href="/instrukciya"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								sm-padding="5px 5px 5px 5px"
								sm-font="normal 700 14px/1.5 &quot;Montserrat&quot;, sans-serif"
							>
								Инструкция
							</Link>
							<Link
								href="https://t.me/uShopWebBot"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="12px 24px 12px 24px"
								background="--dark"
								border-radius="50px"
								transition="--opacityOut"
								hover-opacity=".8"
								target="_blank"
								md-padding="12px 20px 12px 20px"
								sm-align-self="center"
								sm-margin="20px 0px 0px 0px"
							>
								Создать веб-бота
							</Link>
						</Box>
					</Components.QuarklycommunityKitMobileSidePanel>
				</Override>
				<Override
					slot="Cell 0th"
					align-items="center"
					justify-content="flex-end"
					grid-gap="24px"
					display="flex"
					md-display="flex"
					md-grid-gap="16px"
					sm-align-items="center"
				/>
				<Override slot="cell-1">
					<Box
						min-width="100px"
						min-height="100px"
						align-items="center"
						justify-content="center"
						display="flex"
					>
						<Text
							color="--grey"
							text-decoration-line="initial"
							font="--menu"
							transition="--opacityOut"
							hover-opacity=".8"
							padding="5px 5px 5px 5px"
						>
							Ru
						</Text>
						<Link
							href="https://www.ucoz.com/bot/"
							color="#000000"
							text-decoration-line="initial"
							font="--menu"
							transition="--opacityOut"
							hover-opacity=".6"
							padding="5px 5px 5px 5px"
						>
							En
						</Link>
					</Box>
					<Link
						href="/bot/instrukciya/"
						color="--dark"
						text-decoration-line="initial"
						font="--menu"
						transition="--opacityOut"
						hover-opacity=".8"
						padding="5px 5px 5px 5px"
						pointer-events="auto"
						user-select="auto"
						cursor="pointer"
					>
						Инструкция
					</Link>
					<Components.ButtonBot />
				</Override>
				<Override slot="Cell 1" sm-display="none" />
			</Override>
		</Structure>
		<Section padding="140px 0 140px 0" background="linear-gradient(0deg,rgba(2, 2, 2, 0.58) 0%,rgba(2, 2, 2, 0.58) 100%),rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket.png?v=2025-05-22T18:57:37.389Z) center center/cover repeat scroll padding-box" sm-padding="120px 0 120px 0">
			<Override slot="SectionContent" align-items="flex-start" md-align-items="center" />
			<Text
				margin="0px 0px 0px 0px"
				font="--headline1"
				md-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
				color="--white"
				as="h1"
				md-text-align="center"
			>
				Прием платежей в криптовалюте внутри Телеграм при помощи xRocket
			</Text>
			<Text margin="8px 0px 48px 0px" font="--headline3" color="--white" md-text-align="center">
				Инструкция по подключению xRocket в бот-магазине для приема платежей при помощи криптовалют BTC, ETH, USDT, TON и прочие
			</Text>
			<Link
				href="https://t.me/DigitalGood_Bot"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
				text-align="center"
			>
				Пример бота с онлайн оплатой
			</Link>
		</Section>
		<Section padding="60px 0 60px 0" sm-padding="30px 0 30px 0" md-padding="30px 0 90px 0">
			<Text
				id="shop"
				margin="0px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h3"
				color="--dark"
			>
				Подключение xRocket в бот-магазин
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Интеграция с{" "}
				<Link
					href="https://t.me/xrocket?start=i_sxiAoZ1G99"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					target="_blank"
				>
					xRocket
				</Link>
				{" "}позволяет принимать оплату в криптовалютах: TON, BTC, USDT, BNB, BUSD, USDC, ETH.
				<br />
				<br />
				Для подключения необходимо:
				<br />
				<br />
				1. Начать диалог с{" "}
				<Link
					href="https://t.me/xrocket?start=i_sxiAoZ1G99"
					target="_blank"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					xRocket
				</Link>
				{" "}в Telegram. Перейти в раздел:{" "}
				<Strong>
					xRocket API{" "}
				</Strong>
				—{" "}
				<Strong>
					xRocket
				</Strong>
				{" "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Pay
				</Strong>
				{" "}—{" "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Создать{" "}
				</Strong>
				—
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{" "}API-токен
				</Strong>
				.
				<br />
				2. Копируем полученный токен и переходим в раздел "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Способы оплаты
				</Strong>
				"
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket1.png?v=2025-05-22T19:04:30.343Z"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket1.png?v=2025-05-22T19%3A04%3A30.343Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket1.png?v=2025-05-22T19%3A04%3A30.343Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket1.png?v=2025-05-22T19%3A04%3A30.343Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket1.png?v=2025-05-22T19%3A04%3A30.343Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket1.png?v=2025-05-22T19%3A04%3A30.343Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket1.png?v=2025-05-22T19%3A04%3A30.343Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket1.png?v=2025-05-22T19%3A04%3A30.343Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				3. Добавляем новый способ оплаты и выбираем модуль "
				<Strong>
					xRocket
				</Strong>
				" в настройках модуля добавляем наш скопированный токен, а также вам нужно будет выбрать криптовалюту в которой вы будете принимать платежи и ее курс
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket2.png?v=2025-05-22T19:07:44.121Z"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket2.png?v=2025-05-22T19%3A07%3A44.121Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket2.png?v=2025-05-22T19%3A07%3A44.121Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket2.png?v=2025-05-22T19%3A07%3A44.121Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket2.png?v=2025-05-22T19%3A07%3A44.121Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket2.png?v=2025-05-22T19%3A07%3A44.121Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket2.png?v=2025-05-22T19%3A07%3A44.121Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket2.png?v=2025-05-22T19%3A07%3A44.121Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="4px 0px 0px 0px" font="italic 500 16px/160% --fontFamily-googleMontserrat" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--grey">
				Пример подключенной оплаты
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				4. Далее нам нужно скопировать адрес с поля "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					URL для callback-уведомления
				</Strong>
				", это адрес мы устанавливаем в xRocket в раздел "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Вебхуки
				</Strong>
				":{" "}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket3.png?v=2025-05-22T19:09:36.305Z"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket3.png?v=2025-05-22T19%3A09%3A36.305Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket3.png?v=2025-05-22T19%3A09%3A36.305Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket3.png?v=2025-05-22T19%3A09%3A36.305Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket3.png?v=2025-05-22T19%3A09%3A36.305Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket3.png?v=2025-05-22T19%3A09%3A36.305Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket3.png?v=2025-05-22T19%3A09%3A36.305Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/xrocket3.png?v=2025-05-22T19%3A09%3A36.305Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				На скриншоте итоговый результат подключенного вебхука
				<br />
				<br />
				✅ Готово, наш бот подключен
			</Text>
		</Section>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				WebBot магазин в Телеграм
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				Если вы хотите, чтобы магазин сделали за вас, то вы можете воспользоваться нашей услугой бот-магазин под ключ
			</Text>
			<Link
				href="https://bot.divly.pro/"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Заказать веб-бот под ключ
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.ru/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Юридическая информация
					<Link href="https://www.ucoz.ru/details/" />
				</Link>
				<Link
					href="https://www.ucoz.ru/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Условия использования
				</Link>
			</Box>
			<LinkBox href="https://t.me/uShopWeb" target="_blank" transition="--opacityOut" hover-opacity="0.7">
				<Icon category="fa" icon={FaTelegram} size="24px" color="--white" />
			</LinkBox>
		</Section>
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
			<script place={"endOfHead"} rawKey={"65b906fcebf1ff7fe82ff95a"}>
				{"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-59QRNH');"}
			</script>
			<script async={true} src={"//code.jivo.ru/widget/EsmX5tZp4R"} place={"endOfHead"} rawKey={"69b7f73f921c1a779c7c2cc6"} />
		</RawHtml>
	</Theme>;
});